enum DonationCampaignTypes {
  FestiveBauble = 'Festive Bauble',
  GiftCard = 'Gift Card',
  RegularDonation = 'Regular Donation',
  ProductList = 'Product List',
  InnovationFund = 'Innovation Fund',
}
export default DonationCampaignTypes;
